import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUser } from "../../redux/actions/authAction";

const ProtectedRouteHook = () => {
  const dispatch = useDispatch();
  const [userData] = useState(JSON.parse(localStorage.getItem("user")));
  const [isUser, setIsUser] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const currentUser = useSelector((state) => state.authReducer.currentUser);

  if (currentUser.data) {
    if (currentUser.statusCode === 200) {
      if (currentUser.data) {
        localStorage.setItem("user", JSON.stringify(currentUser.data));
      }
    } else {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    }
  }

  useEffect(() => {
    if (userData != null) {
      dispatch(getLoggedUser());
      if (userData.role === "user") {
        setIsUser(true);
        setIsAdmin(false);
      } else {
        setIsUser(false);
        setIsAdmin(true);
      }
    } else {
      setIsAdmin(false);
      setIsUser(false);
    }
  }, [dispatch, userData]);

  return [isUser, isAdmin, userData];
};

export default ProtectedRouteHook;
